import { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { Option } from 'types';
import { Selection } from 'types/api/selection.type';

import { useAppSelector } from 'redux/hooks';

import { selectionDataService } from 'services/selection.service';

const useSelectionModal = (productId: string, onClose: () => void) => {
  const { season, warehouse } = useAppSelector((state) => state.settings);

  const { t } = useTranslation();

  const { control, handleSubmit } = useForm();

  const [options, optionsSet] = useState<Option[]>([]);

  const mapSelectionsIntoOptions = (data: Selection[]): Option[] =>
    data.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const onSubmit = (data: FieldValues) => {
    selectionDataService.postProduct(data.id, productId).then(() => {
      onClose();
      toast.success(t('product.addedSuccessfully'));
    });
  };

  useEffect(() => {
    if (season) {
      selectionDataService.getAll(season, warehouse.code).then((res) => {
        if (res.data) {
          optionsSet(mapSelectionsIntoOptions(res.data));
        }
      });
    }
  }, [season, warehouse.code]);

  return {
    control,
    handleSubmit,
    options,
    onSubmit,
    t,
  };
};

export { useSelectionModal };
